// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KpisPDL_card__HPeRT {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 12px;
  border: 1px solid #c6d9df;
  border-radius: 10px;
  background: #cddaea;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 1px 3px rgba(16, 24, 40, 0.06);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.KpisPDL_card__HPeRT:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 12px rgba(16, 24, 40, 0.08);
}

/* LEFT CONTENT */

.KpisPDL_cardContent__SS4Oh {
  min-width: 0;
  flex: 1 1;

  display: flex;
  flex-direction: column;
  justify-content: center;

  height: 100%;
}

/* LABEL */

.KpisPDL_labelRow__TFcys {
  display: flex;
  align-items: center;

  gap: 5px;

  min-width: 0;

  line-height: 1;
}

.KpisPDL_label__Fhxao {
  font-size: 0.68rem;
  font-weight: 600;

  letter-spacing: 0.04em;
  text-transform: uppercase;

  color: #6b7280;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* DOWNLOAD */

.KpisPDL_downloadIcon__Jy2H4 {
  flex-shrink: 0;

  color: #6b7280;

  cursor: pointer;
}

.KpisPDL_downloadIcon__Jy2H4:hover {
  color: #022352;
}

/* VALUE */

.KpisPDL_value__imQei {
  margin-top: 4px;
  margin-right: auto;
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1;
  color: #022352;
  white-space: nowrap;
}

/* ICON */

.KpisPDL_iconWrapper__jI2GR {
  width: 48px;
  height: 50px;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;
}

.KpisPDL_icon__sI-CZ {
  width: 36px;
  height: 36px;

  color: #4b71a2;
}

/* TABLET */

@media (max-width: 991.98px) {
  .KpisPDL_card__HPeRT {
    height: 60px;
    padding: 5px 10px;
  }

  .KpisPDL_label__Fhxao {
    font-size: 0.65rem;
  }

  .KpisPDL_value__imQei {
    font-size: 1.25rem;
  }

  .KpisPDL_iconWrapper__jI2GR {
    width: 44px;
  }

  .KpisPDL_icon__sI-CZ {
    width: 32px;
    height: 32px;
  }
}

/* MOBILE */

@media (max-width: 575.98px) {
  .KpisPDL_card__HPeRT {
    height: 60px;
    padding: 5px 9px;
  }

  .KpisPDL_label__Fhxao {
    font-size: 0.62rem;
  }

  .KpisPDL_value__imQei {
    font-size: 1.2rem;
  }

  .KpisPDL_iconWrapper__jI2GR {
    width: 42px;
  }

  .KpisPDL_icon__sI-CZ {
    width: 30px;
    height: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/SmartCIty/PDL/Kpis/KpisPDL.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,8EAA8E;EAC9E,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,iBAAiB;;AAEjB;EACE,YAAY;EACZ,SAAO;;EAEP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;EAEvB,YAAY;AACd;;AAEA,UAAU;;AAEV;EACE,aAAa;EACb,mBAAmB;;EAEnB,QAAQ;;EAER,YAAY;;EAEZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;;EAEhB,sBAAsB;EACtB,yBAAyB;;EAEzB,cAAc;;EAEd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,aAAa;;AAEb;EACE,cAAc;;EAEd,cAAc;;EAEd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;;AAEV;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA,SAAS;;AAET;EACE,WAAW;EACX,YAAY;;EAEZ,cAAc;;EAEd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,cAAc;AAChB;;AAEA,WAAW;;AAEX;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,WAAW;;AAEX;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".card {\n  height: 60px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 5px 12px;\n  border: 1px solid #c6d9df;\n  border-radius: 10px;\n  background: #cddaea;\n  overflow: hidden;\n  box-sizing: border-box;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 1px 3px rgba(16, 24, 40, 0.06);\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 12px rgba(16, 24, 40, 0.08);\n}\n\n/* LEFT CONTENT */\n\n.cardContent {\n  min-width: 0;\n  flex: 1;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  height: 100%;\n}\n\n/* LABEL */\n\n.labelRow {\n  display: flex;\n  align-items: center;\n\n  gap: 5px;\n\n  min-width: 0;\n\n  line-height: 1;\n}\n\n.label {\n  font-size: 0.68rem;\n  font-weight: 600;\n\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n\n  color: #6b7280;\n\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* DOWNLOAD */\n\n.downloadIcon {\n  flex-shrink: 0;\n\n  color: #6b7280;\n\n  cursor: pointer;\n}\n\n.downloadIcon:hover {\n  color: #022352;\n}\n\n/* VALUE */\n\n.value {\n  margin-top: 4px;\n  margin-right: auto;\n  font-size: 1.35rem;\n  font-weight: 800;\n  line-height: 1;\n  color: #022352;\n  white-space: nowrap;\n}\n\n/* ICON */\n\n.iconWrapper {\n  width: 48px;\n  height: 50px;\n\n  flex-shrink: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon {\n  width: 36px;\n  height: 36px;\n\n  color: #4b71a2;\n}\n\n/* TABLET */\n\n@media (max-width: 991.98px) {\n  .card {\n    height: 60px;\n    padding: 5px 10px;\n  }\n\n  .label {\n    font-size: 0.65rem;\n  }\n\n  .value {\n    font-size: 1.25rem;\n  }\n\n  .iconWrapper {\n    width: 44px;\n  }\n\n  .icon {\n    width: 32px;\n    height: 32px;\n  }\n}\n\n/* MOBILE */\n\n@media (max-width: 575.98px) {\n  .card {\n    height: 60px;\n    padding: 5px 9px;\n  }\n\n  .label {\n    font-size: 0.62rem;\n  }\n\n  .value {\n    font-size: 1.2rem;\n  }\n\n  .iconWrapper {\n    width: 42px;\n  }\n\n  .icon {\n    width: 30px;\n    height: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `KpisPDL_card__HPeRT`,
	"cardContent": `KpisPDL_cardContent__SS4Oh`,
	"labelRow": `KpisPDL_labelRow__TFcys`,
	"label": `KpisPDL_label__Fhxao`,
	"downloadIcon": `KpisPDL_downloadIcon__Jy2H4`,
	"value": `KpisPDL_value__imQei`,
	"iconWrapper": `KpisPDL_iconWrapper__jI2GR`,
	"icon": `KpisPDL_icon__sI-CZ`
};
export default ___CSS_LOADER_EXPORT___;
